import React, { FC, PropsWithChildren, ReactElement } from "react"
import { Flex, Group, Stack, Title } from "@mantine/core"
import { IconArrowLeft } from "@tabler/icons-react"
import TransparentButton from "../../inputs/transparent-button/TransparentButton"
import { useNavigate } from "react-router-dom"

type PageProps = {
    title: string | ReactElement
    subtitle?: string | ReactElement
    flipTitles?: boolean
    primaryAction?: ReactElement
    actions?: [ReactElement[]] | [ReactElement[], ReactElement[]]
    returnAction?: string | { label: string; target: string }
}

const Page: FC<PropsWithChildren<PageProps>> = ({
    children,
    title,
    subtitle,
    flipTitles = false,
    primaryAction,
    actions,
    returnAction,
}) => {
    const navigate = useNavigate()

    return (
        <Stack spacing="2rem">
            <Group position="apart" align="baseline">
                <Stack spacing={0}>
                    {returnAction && (
                        <div>
                            {typeof returnAction === "string" ? (
                                <TransparentButton
                                    leftIcon={<IconArrowLeft size={24} />}
                                    onClick={() => navigate("..", { relative: "path" })}
                                >
                                    {returnAction}
                                </TransparentButton>
                            ) : (
                                <TransparentButton
                                    leftIcon={<IconArrowLeft size={24} />}
                                    onClick={() => navigate(returnAction.target)}
                                >
                                    {returnAction.label}
                                </TransparentButton>
                            )}
                        </div>
                    )}
                    <Flex direction={flipTitles ? "column-reverse" : "column"}>
                        {typeof title === "string" ? <Title color="gray.0">{title}</Title> : title}
                        {typeof subtitle === "string" ? (
                            <Title color="gray.0" opacity={0.5} order={2}>
                                {subtitle}
                            </Title>
                        ) : (
                            subtitle
                        )}
                    </Flex>
                </Stack>
                {primaryAction}
            </Group>
            {actions && (
                <Group position="apart">
                    <Group>{...actions[0]}</Group>
                    {actions[1] && <Group>{...actions[1]}</Group>}
                </Group>
            )}
            {children}
        </Stack>
    )
}

export default Page
